import CustomElement from '../core/custom.js'

export default window.customElements.define(
  'block-clients',
  class extends CustomElement {
    constructor() {
      super()

      this._onMouseEnter = this.onMouseEnter.bind(this)
    }

    connectedCallback() {
      super.connectedCallback()

      this._clients = Array.from(this.querySelectorAll('.js-client'))
      this._infos = Array.from(this.querySelectorAll('.js-info'))

      const observer = new IntersectionObserver(
        (entries) => {
          const currentEntry = entries.find((e) => e.isIntersecting)
          currentEntry &&
            this.setActive(
              Number(currentEntry.target.getAttribute('data-index'))
            )
        },
        { rootMargin: '-50% 0px', threshold: 0 }
      )

      const visibilityObserver = new IntersectionObserver(
        ([entry]) => {
          entry.target.classList.toggle('is-visible', entry.isIntersecting)
        },
        { rootMargin: '-50% 0px', threshold: 0 }
      )
      visibilityObserver.observe(this)

      this._clients.forEach((client, i) => {
        client.addEventListener('pointerenter', this._onMouseEnter)
        observer.observe(client)
      })
    }

    disconnectedCallback() {
      super.disconnectedCallback()

      this._clients.forEach((client) => {
        client.removeEventListener('pointerenter', this._onMouseEnter)
      })
    }

    onMouseEnter(event) {
      const index = Number(event.currentTarget.getAttribute('data-index'))
      this.setActive(index)
    }

    setActive(index) {
      this._clients.forEach((client, i) => {
        client.classList.remove('is-active')

        if (index === i) {
          client.classList.add('is-active')
        }
      })

      this._infos.forEach((info, i) => {
        info.classList.remove('is-active')

        if (index === i) {
          info.classList.add('is-active')
        }
      })
    }
  }
)
